import Dialog from "@rio-cloud/rio-uikit/Dialog";
import ConfirmationDialog from "@rio-cloud/rio-uikit/ConfirmationDialog";

interface Props {
  show: boolean;
  title: string;
  content: string;
  bsSize?: string;
  onClickConfirm: () => void | Promise<void>;
  onClickCancel: () => void;
  cancelButtonText?: string;
  confirmButtonText?: React.ReactNode;
}

const ConfirmDialog = ({
  show,
  title,
  content,
  bsSize,
  onClickConfirm,
  onClickCancel,
  cancelButtonText,
  confirmButtonText,
}: Props) => {
  return (
    <div>
      <ConfirmationDialog
        show={show}
        title={title}
        content={content}
        bsSize={Dialog.SIZE_SM}
        onClickConfirm={onClickConfirm}
        onClickCancel={onClickCancel}
        cancelButtonText={cancelButtonText ?? "Cancelar"}
        confirmButtonText={
          <>
            <span className="rioglyph rioglyph-ok margin-right-5" />
            <span>{confirmButtonText ?? "Sim"}</span>
          </>
        }
        useOverflow
      />
    </div>
  );
};

export default ConfirmDialog;
